import { postJSON, getJSON } from '../utils/fetchUtils'
import { formatDate } from 'utils/serializers/memberSerializers'

export function authenticateWelcomeBack({ dob, zipCode, applicationId }) {
  const data = {
    date_of_birth: formatDate(dob),
    zip_code: zipCode,
    application_id: applicationId
  }
  return postJSON(`/authenticate-zip-dob/`, data)
}

export function refreshToken(data) {
  return postJSON('/token/refresh/', data)
}

export function logout(data) {
  return postJSON('/logout/', data)
}

export function validateBrokerToken() {
  return postJSON('/auth/broker/validate/')
}
